<template>
  <div id="admin-account-basic-info-detail" >
    <div class="vx-card" style="height: calc(100vh - 130px); position: relative;" >


      <!-- 右上船員アバター表示領域 -->
      <div class="flex w-full justify-end items-center" style="position: absolute; top: 0; right: 10px; z-index: 9;">

        <div class="mr-2 increment-user-button" style="width: 2rem; height: 2rem;" :style="{ color: hasPrevAdminAccount ? AISEA_COLOR.GRAY : AISEA_COLOR.LIGHT_GRAY, cursor: hasPrevAdminAccount ? 'pointer' : null }"  @click="onClickPrevAdminAccount" >
          <vs-icon icon="chevron_left" size="25px" />
        </div>

        <div  class="flex flex-wrap justify-end items-center">
          <p
            class="text-inherit mr-4" 
          >{{ localData.profile.name }}</p
          >
          <vs-avatar
            :src="avatar"
            :text="avatarInitials"
            class="flex-shrink-0 mr-2"
            size="30px"
            style="cursor: default;"
            :color="AISEA_COLOR.LIGHT_BLUE"
          />
        </div>

        <div class="ml-2 increment-user-button" style="width: 2rem; height: 2rem;" :style="{ color: hasNextAdminAccount ? AISEA_COLOR.GRAY : AISEA_COLOR.LIGHT_GRAY, cursor: hasNextAdminAccount ? 'pointer' : null  }" @click="onClickNextAdminAccount" >
          <vs-icon icon="chevron_right" size="25px"  />
        </div>

      </div>



      <vs-tabs v-model="activeTab" alignment="left" :color="AISEA_COLOR.BLUE">
        <vs-tab label="陸上従業員基本情報">

          <div class="flex justify-between items-center px-6 py-2">
            <div class="aisea-text-18-600-dark-gray">陸上従業員基本情報</div>
            <div class="flex items-centers">
              <div class="">
                <vs-tooltip text="編集" position="bottom" >
                  <vs-button
                    @click="onEdit"
                    type="flat"
                    icon="edit"
                    :color="AISEA_COLOR.GRAY"
                    size="large"
                  ></vs-button>
                </vs-tooltip>
              </div>
              <div>
                <vs-tooltip text="削除" position="bottom" >
                  <vs-button
                    type="flat"
                    icon="delete_outline"
                    @click="confirmDelete"
                    :color="AISEA_COLOR.GRAY"
                    :disabled="isSelf"
                    size="large"
                  ></vs-button>
                </vs-tooltip>
              </div>
              <div class="ml-6">
                <vs-button
                  @click="onChangePassword"
                  icon="lock_reset"
                  type="border"
                  :color="AISEA_COLOR.BLUE"
                >パスワード変更</vs-button>
              </div>

            </div>
          </div>
          <vs-divider class="m-0 mb-2" />

          <!-- max-h-full -->
          <div class="scroll-area pt-0 pr-2 pb-2 pl-2" style="overflow-y: auto; height: calc(100vh - 220px);">
            <div class="flex">
              <div class="flex items-center">
                <!-- アバターアイコン -->
                <vs-avatar
                  :src="avatar"
                  :text="avatarInitials"
                  class="flex-shrink-0 mr-2 admin-account-large-avatar"
                  style="font-size: xx-large; cursor: default;"
                  size="100px"
                  :color="AISEA_COLOR.LIGHT_BLUE"
                  icon="person_outline"
                />

                <!-- 名前 -->
                <div class="ml-10">
                  <div class="aisea-text-12-400-gray">{{ localData.profile.name_kana }}</div>
                  <div class="aisea-text-28-400-black">{{ localData.profile.name }}</div>
                </div>
              </div>
            </div>

            <!-- 情報 -->
            <div class="mt-8 text-sm">
              <vs-row>
                <vs-col vs-w="3" class="aisea-text-14-400-black pl-4" >部署</vs-col>
                <vs-col vs-w="9" class="aisea-text-16-400-black" >{{ localData.profile.department }}</vs-col>
              </vs-row>
              <vs-divider />
              <vs-row>
                <vs-col vs-w="3" class="aisea-text-14-400-black pl-4" >役職</vs-col>
                <vs-col vs-w="9" class="aisea-text-16-400-black" >{{ localData.profile.title }}</vs-col>
              </vs-row>
              <vs-divider />
              <vs-row>
                <vs-col vs-w="3" class="aisea-text-14-400-black pl-4" >電話番号</vs-col>
                <vs-col vs-w="9" class="aisea-text-16-400-black" >{{ localData.profile.phone_number }}</vs-col>
              </vs-row>
              <vs-divider />
              <vs-row>
                <vs-col vs-w="3" class="aisea-text-14-400-black pl-4" >メールアドレス</vs-col>
                <vs-col vs-w="9" class="aisea-text-16-400-black" >{{ localData.profile.email_address }}</vs-col>
              </vs-row>
            </div>
          </div>

        </vs-tab>
      </vs-tabs>
    </div>


    <!-- サイドバー -->
    <crew-controls-sidebar 
      :activeSidebarCrew.sync="activeSidebarCrew"
      :dialogTitle="dialogTitle"
    >
      <template v-slot:crewControlSidebarBody >

        <div v-if="activeSidebarCrew">
          <!-- 陸上従業員 詳細 -->
          <admin-account-basic-info-edit
            :inputParam="localData"
            :activeSidebarCrew="activeSidebarCrew"
            @close="activeSidebarCrew = false"
            @reloadList="onReload"
            @updatedId="updatedId($event)"
          />
        </div>

      </template>
    </crew-controls-sidebar>

    <vs-prompt
      title="陸上従業員アカウント削除"
      type="confirm"
      :color="AISEA_COLOR.BLUE"
      accept-text="実行"
      cancel-text="キャンセル"
      :active.sync="showDeletePrompt"
      @accept="onDelete"
      @cancel="onDeleteCancel"
      class="admin-account-list-delete-confirm"
    >
      <div>
        {{ deleteDispId }}のアカウントを削除しますか？<br />
        データは完全に削除され、閲覧できなくなります。
      </div>
    </vs-prompt>


    <vs-prompt
      title="パスワード変更"
      type="confirm"
      :color="AISEA_COLOR.BLUE"
      accept-text="送信"
      cancel-text="キャンセル"
      :active.sync="showPasswordChangeMailPrompt"
      @accept="onPasswordChangeMail"
      @cancel="onPasswordChangeMailCancel"
      class="admin-account-password-change-mail-confirm"
      id="test"
    >
      <div>

        <div class="mb-4" >
          登録済のメールアドレスにパスワード変更用のURLを送信します。
        </div>
        <div class="flex w-full justify-start items-start admin-account-edit-form-row">
          <div class="w-full">
            <vs-input
              class="w-full"
              label="メールアドレス"
              v-model="localData.profile.email_address"
              name="email_address"
              disabled="true"
              data-vv-as="メールアドレス"
            />
          </div>
        </div>

      </div>
    </vs-prompt>

  </div>
</template>

<script>
import Vue from "vue";
import { ColorMixin } from "@/mixins";
import { storage } from "@/firebase/firebaseConfig";
import CrewControlsSidebar from "../page-layout-template/components/CrewControlsSidebar.vue";
import AdminAccountBasicInfoEdit from "./components/AdminAccountBasicInfoEdit.vue";
import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const enterpriseAdminAccountApi = AiseaApiFactory.get("enterpriseAdminAccount");
const enterpriseAdminAccountPasswordApi = AiseaApiFactory.get("enterpriseAdminAccountPassword");


export default {
  name: "AdminAccountBasicInfoDetail",
  mixins: [ColorMixin],  
  components: {
    CrewControlsSidebar,
    AdminAccountBasicInfoEdit,
  },
  data() {
    return {
      adminAccountId: '',
      localData: { profile: {}, },
      avatar: null,
      avatarName: '',
      avatarInitials: '',
      activeSidebarCrew: false,
      type: '',
      activePasswordDialog: false,
      deleteDispId: '',
      showDeletePrompt: false,
      showPasswordChangeMailPrompt: false,
      adminAccountList: [],
      activeTab: 0,
      clipboardNotesIcon: require(`@/assets/images/icons/crew/clipboard_notes.svg`),
      dialogTitle: '陸上従業員基本情報編集',
    };
  },
  computed: {
    hasPrevAdminAccount() {
      const findIndex = this.adminAccountList.findIndex(x => x.enterprise_account_id === this.adminAccountId);
      return !isNaN(findIndex) && findIndex > 0;
    },
    hasNextAdminAccount() {
      const findIndex = this.adminAccountList.findIndex(x => x.enterprise_account_id === this.adminAccountId);
      return !isNaN(findIndex) && findIndex < this.adminAccountList.length - 1;
    },
    paramId() {
      return this.$route.params.id;
    },
    isSelf() {
      return this.$store.state.auth.user.account_id === this.localData.profile.email_address;
    }
  },
  watch: {
    activeSidebarCrew(val) {
      if (! val ) {
        this.type = '';
      }
    },
    paramId() {
      this.adminAccountId = this.$route.params.id;
      this.initAdminAccount(this.adminAccountId);
    },
   },  
   methods: {

    async initAdminAccount(adminAccountId) {

      const res = await enterpriseAdminAccountApi.fetch(adminAccountId);
      // console.debug("### res.data", res.data);

      this.localData = res.data;
      if ( ! this.localData.profile ) {
        this.localData.profile = {};
      }

      this.setAvatar(this.localData.profile && this.localData.profile.picture && this.localData.profile.picture['thumbnail_path'],  this.localData.profile['name'] && this.localData.profile['name']);
    },

    setAvatar( thumbnailPath, avatarName ) {
      this.avatarName = avatarName;
      // this.avatarInitials = avatarName ? avatarName.charAt( 0 ) : '';
      if ( thumbnailPath ) {
        storage
          .child(thumbnailPath)
          .getDownloadURL()
          .then(response => {
            this.avatar = response;
          });
      } else {
        this.avatar = null;
      }
    },

    async initAdminAccountList() {
      // 陸上従業員の横切り替えに必要
      const res = await enterpriseAdminAccountApi.search({ srot_target: 'NAME_KANA', sort_order: 'ASC', active_type: 'ACTIVE', page: 0, limit: 999,  });
      this.adminAccountList = res.data.enterprise_accounts || [];
    },

    updatedId(adminAccountId) {
      console.debug("### updatedId", adminAccountId);
      this.initAdminAccount(adminAccountId);
    },

    onReload() {
      console.debug("### onReload");
      this.initAdminAccount(this.adminAccountId);
    },

    onEdit() {
      this.type = "edit";
      this.activeSidebarCrew = true;

    },
    onChangePassword() {
      this.showPasswordChangeMailPrompt = true;

    },

    confirmDelete() {
      this.deleteDispId = this.localData.profile.name;
      this.showDeletePrompt = true;
    },
    async onDelete() {
      this.showDeletePrompt = true;
      console.debug("### 削除API", this.adminAccountId);

      try {
        this.$vs.loading({ color: this.AISEA_COLOR.BLUE, });
        const res = await enterpriseAdminAccountApi.delete(this.adminAccountId); // TODO: あとで有効化
        //const res = {};
        this.$vs.loading.close();
        if ( res.status ) {
          this.$vs.notify({
            title: `陸上従業員基本情報設定`,
            text: `${this.deleteDispId}の基本情報を削除しました`,
            color: "success",
            icon: "done"
          });
        } else {
          Vue.$log.warn("error at enterpriseAdminAccountApi.delete() ", this.localData.enterprise_account_id, res);
          this.$vs.notify({
            title: `陸上従業員基本情報設定`,
            text: `${this.deleteDispId}の基本情報を削除できませんでした`,
            color: "warning",
            icon: "done"
          });
        }
      } catch (e) {
        this.$vs.loading.close();
        Vue.$log.warn("error at enterpriseAdminAccountApi.delete() ", this.localData.enterprise_account_id, e);
        this.$vs.notify({
          title: `陸上従業員基本情報設定`,
          text: `${this.deleteDispId}の基本情報を削除できませんでした`,
          color: "warning",
            icon: "done"
        });
      }  


      this.$nextTick(() => {
        this.deleteDispId = '';
        this.showDeletePrompt = false;

        this.$router.push({
          name: "enterprise-management-crew-admin-account-list",
        });

      });
    },

    onDeleteCancel() {
      this.showDeletePrompt = true;
      this.$nextTick(() => {
        console.debug("### onDeleteCancel",this.showDeletePrompt );
        this.deleteDispId = '';
        this.showDeletePrompt = false;
      });
    },

    async onPasswordChangeMail() {
      this.showPasswordChangeMailPrompt = true;
      console.debug("### 法人Adminアカウントパスワード変更の招待API", this.localData.enterprise_account_id);

      try {
        this.$vs.loading({ color: this.AISEA_COLOR.BLUE, });
        const res = await enterpriseAdminAccountPasswordApi.invites(this.localData.enterprise_account_id);
        this.$vs.loading.close();

        if ( res.status ) {
          this.$vs.notify({
            title: `パスワード再設定`,
            text: `再設定用URLのメールを送信しました`,
            color: "success",
            icon: "done"
          });
        } else {
          Vue.$log.warn("error at enterpriseAdminAccountPasswordApi.invites() ", this.localData.enterprise_account_id, res);
          this.$vs.notify({
            title: `パスワード再設定`,
            text: `再設定用URLのメールを送信できませんでした`,
            color: "warning",
            icon: "done"
          });
        }
      } catch (e) {
        this.$vs.loading.close();
        Vue.$log.warn("error at enterpriseAdminAccountPasswordApi.invites() ", this.localData.enterprise_account_id, e);
        this.$vs.notify({
          title: `パスワード再設定`,
          text: `再設定用URLのメールを送信できませんでした`,
          color: "warning",
            icon: "done"
        });
      }  

      this.$nextTick(() => {
        this.showPasswordChangeMailPrompt = false;
      });
    },
    onPasswordChangeMailCancel() {
      this.showPasswordChangeMailPrompt = true;
      this.$nextTick(() => {
        console.debug("### onPasswordChangeMailCancel", this.showPasswordChangeMailPrompt );
        this.deleteDispId = '';
        this.showPasswordChangeMailPrompt = false;
      });
    },

    onClickPrevAdminAccount() {
      if ( this.hasPrevAdminAccount ) {
        this.$vs.loading({ color: this.AISEA_COLOR.BLUE, });

        const findIndex = this.adminAccountList.findIndex(x => x.enterprise_account_id === this.adminAccountId);
        const prevAdminAccountId = this.adminAccountList[findIndex -1].enterprise_account_id;

        this.$router.push({
          name: this.$route.name,
          params: {id: prevAdminAccountId, },
        });
        this.$nextTick(() => {
          this.$vs.loading.close();
        });
      }
    },

    onClickNextAdminAccount() {
      if ( this.hasNextAdminAccount ) {
        this.$vs.loading({ color: this.AISEA_COLOR.BLUE, });
        const findIndex = this.adminAccountList.findIndex(x => x.enterprise_account_id === this.adminAccountId);
        const nextAdminAccountId = this.adminAccountList[findIndex +1].enterprise_account_id;
        this.$router.push({
          name: this.$route.name,
          params: {id: nextAdminAccountId, },
        });
        this.$nextTick(() => {
          this.$vs.loading.close();
        });
      }
    },

    setVstabHeaderIcon() {

      this.$nextTick(() => {
        // vstabボタンにimgアイコンを付与する。二重付与防止付き。
        const vsTabsBtnElList = Array.from(document.querySelectorAll("button.vs-tabs--btn"))
                .filter(e0 => Array.from(e0.childNodes).filter(e1 => e1.id && e1.id.startsWith('aisea-icon') ).length === 0);
        
        // buttonタグ内のspanタグの一つ前にsvgを差し込む
        vsTabsBtnElList.forEach(e0 => {
          e0.childNodes.forEach(async e1 => {
            if ( String(e1.tagName).toUpperCase() === 'SPAN' ) {

              const inlineSvgText = await fetch(this.clipboardNotesIcon)
                .then(response => {
                  return response.text();
                });

              const el = document.createElement('span');
              el.id = "aisea-icon-clipboard-note";
              el.classList.add("aisea-vstab-icon");
              el.innerHTML = inlineSvgText;
              e0.insertBefore(el, e1);
            }
          });
        });
      });
    },



  },
  created() {
    this.adminAccountId = this.$route.params.id;
    this.initAdminAccount(this.adminAccountId);
    this.initAdminAccountList();
  },
  mounted() {
    let routerViewElement = document.getElementsByClassName("router-view");
    routerViewElement[0].style.padding = "2.2rem";
    this.setVstabHeaderIcon();
  }
}
</script>

<style lang="scss" >
@import "@/assets/scss/aisea/_variables.scss";

#admin-account-basic-info-detail {


  // .vs-tabs--btn {
  //   padding-right:  20px;
  //   padding-top:    14px;
  //   padding-bottom: 8px;
  //   background-color: $aisea-white;
  //   margin-bottom: -1px;
  //   border-bottom: 1px solid $aisea-light-gray;
  // }

  .admin-account-large-avatar {
    span {
      font-size: 60px;
    }
  }

  .vs-tabs--btn {
    // width: 11rem;
    text-align: left;
    padding-left:   30px;
    padding-right:  20px;
    padding-top:    12px;
    padding-bottom:  6px;
    background-color: $aisea-white;
    margin-bottom: -1px;
    border-bottom: 1px solid $aisea-light-gray;
    position: relative;

    font-family: $aisea-font-family;
    font-size: 16px;
    font-weight: 400;
    color: $aisea-dark-gray;

    .vs-tabs--btn-icon {
      // vstabのアイコンが material-icon の時の指定
      color: $aisea-gray !important;
      position: absolute;
      top: 16px;
      left: 20px;
    }
    .aisea-vstab-icon {
      // vstabのアイコンが オリジナルアイコン の時の指定
      position: absolute;
      top: 16px;
      left: 10px;
      path {
        fill: $aisea-gray;
      }
    }

  }


  // .activeChild button.vs-tabs--btn {
  //   padding-right: 20px;
  //   color: $aisea-blue;
  //   background-color: $aisea-pure-white;
  //   border-left: 1px solid $aisea-light-gray;
  //   border-right: 1px solid $aisea-light-gray;
  //   margin-bottom: -1px;
  //   border-bottom: 1px solid $aisea-pure-white;
  // }
  .activeChild button.vs-tabs--btn {
    padding-right: 20px;
    background-color: $aisea-pure-white;
    border-left: 1px solid $aisea-light-gray;
    border-right: 1px solid $aisea-light-gray;
    margin-bottom: -1px;
    border-bottom: 1px solid $aisea-pure-white;

    font-family: $aisea-font-family;
    font-size: 16px;
    font-weight: 600;
    color: $aisea-blue;

    .vs-tabs--btn-icon {
      // vstabのアイコンが material-icon の時の指定
      color: $aisea-blue !important;
    }
    .aisea-vstab-icon {
      // vstabのアイコンが オリジナルアイコン の時の指定
      vertical-align: bottom;
      path {
        fill: $aisea-blue;
      }
    }
  }
  .line-vs-tabs {
    padding-right: 20px;
    top: 0px !important;
    height: 3px !important;
    z-index: 999;
  }
  .vs-tabs--ul {
    border-bottom: 1px solid $aisea-light-gray;
  }

  .increment-user-button{
    :hover {
      border-radius: 4px;
      background-color: $aisea-white;
    }
  }

//
  .aisea-vstab-icon {
    margin-right: 8px;
    vertical-align: baseline;
    path {
      fill: $aisea-blue;
    }
  }
//
}

.admin-account-password-change-mail-confirm {  
  .vs-dialog {
    min-width: 540px;
  }
}


</style>
